<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const footer = window.gsdNowFooter ?? {};
const route = useRoute();

// Routes whose `default` component is CalendarPage: 'calendar' and 'event-view'.
const footerClass = computed(() => ({
  'gsd-footer--calendar': route.name === 'calendar' || route.name === 'event-view',
}));
</script>

<template>
  <footer :class="footerClass">
    <div class="gsd-footer-container">
      <div class="gsd-footer-container-inner">
        <div v-if="footer.description" class="gsd-footer-description">
          <p>{{ footer.description }}</p>
        </div>
        <ul v-if="footer.links?.length" class="gsd-footer-links">
          <li v-for="(row, i) in footer.links" :key="i">
            <a
              :href="row.url?.url || '#'"
              :target="row.url?.target ? '_blank' : null"
              rel="noopener"
            >
              {{ row.label || row.url?.title }}
            </a>
          </li>
        </ul>
        <div class="gsd-footer-disclaimer">
          <div class="footer-logo">
            <img v-if="footer.logo" :src="footer.logo.url" :alt="footer.logo.alt" />
          </div>
          <div class="gsd-footer-disclaimer-body">
            <p v-if="footer.copyright_text" v-html="footer.copyright_text" />
            <p v-if="footer.disclaimer" v-html="footer.disclaimer" />
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
